export default [
  {
    path: "/working-day",
    name: "working_days_index",
    component: () => import("@/pages/working_days/Index.vue")
  },
  {
    path: "/working-day-status",
    name: "working_days_status",
    component: () => import("@/pages/working_days/OutletStatusPage.vue")
  },
  {
    path: "/working-day-on",
    name: "working_days_on",
    component: () => import("@/pages/working_days/OutletStatusPage.vue")
  },
  {
    path: "/working-day-off",
    name: "working_days_off",
    component: () => import("@/pages/working_days/OutletStatusPage.vue")
  }
];
